<div class="visitor-registration-summary">
    <sc-title>
      <sc-dictionary-label dictionaryKey="tmc-yard.widgets.registration-terminal.visitor-registration-qrcode.title"></sc-dictionary-label>
    </sc-title>

    <sc-sub-title>
      <sc-dictionary-label dictionaryKey="tmc-yard.widgets.registration-terminal.visitor-registration-qrcode.description"></sc-dictionary-label>
    </sc-sub-title>

    <mat-card>
      <sc-flex >
        <div class="qr-code-box">
          <qrcode class="qr-code" *ngIf="qrCodeContent" [scale]="qrScale"
              [colorDark]="darkMode?'#ffffff':'#000000'" [colorLight]="darkMode?'#000000':'#ffffff'"
              [qrdata]="qrCodeContent" [errorCorrectionLevel]="'M'"></qrcode>
        </div>
        <table>
            <tr>
              <td class="label"><label>
                <sc-dictionary-label dictionaryKey="tmc-yard.widgets.registration-terminal.visitor-registration-summary.label.company"></sc-dictionary-label>:</label></td>
              <td class="bold">{{company}}</td>
          </tr>
            <tr>
                <td class="label"><label>
                  <sc-dictionary-label dictionaryKey="tmc-yard.widgets.registration-terminal.visitor-registration-summary.label.name"></sc-dictionary-label>:</label></td>
                <td class="bold">{{lastname}}</td>
            </tr>
            <tr>
                <td class="label"><label>
                  <sc-dictionary-label dictionaryKey="tmc-yard.widgets.registration-terminal.visitor-registration-summary.label.firstname"></sc-dictionary-label>:</label></td>
                <td class="bold">{{firstname}}</td>
            </tr>
            <tr>
              <td class="label"><label>
                <sc-dictionary-label dictionaryKey="tmc-yard.widgets.registration-terminal.visitor-registration-summary.label.numberPlate"></sc-dictionary-label>:</label></td>
              <td class="bold">{{numberPlate}}</td>
          </tr>
        </table>
      </sc-flex>
      <div>
        <button matButton (click)="download()">Download Registrierung</button>
      </div>
    </mat-card>

</div>
